module.exports = __webpack_public_path__ + "img/UsersIcon.a7c131ff.svg";